import { Container, Grid } from "@mui/material";
import React from "react";
import SectionHeading from "../../Components/SectionHeading";

import tweet1 from "../../images/tweet1.png"
import tweet2 from "../../images/tweet2.png"
import tweet3 from "../../images/tweet3.png"
import metaverse from "../../images/metaverse.png"
import AnnouncementCards from "../../Components/AnnouncementCards";

const Announcements = () => {
    return(
        <div className="py-5">
            <Container>
                <Grid
                    container
                    justifyContent="flex-start"
                    alignContent="center"
                >
                    <Grid
                        xs={12}
                        className="align-self-center"
                        data-aos="fade-up"
                    >
                        <SectionHeading
                            subHeading = "Stay Upto Date"
                            heading = "Announcements" 
                            customClass = " mx-auto text-center"
                        />
                    </Grid>
                    <Grid
                        container
                        xs={12}
                        className="text-center align-self-center pt-3"
                    >
                        <Grid 
                            xs={12}
                            sm={6}
                            md={4}
                            className="px-3 my-4"
                            data-aos="zoom-in"
                        >
                            <blockquote class="twitter-tweet" data-dnt="true" data-theme="dark"><p lang="en" dir="ltr">Day 2 of going strong and helping MSR in attaining an easy moonshot! 🚀<br/><br/>TG: <a href="https://t.co/yc8Y8CrqFi">https://t.co/yc8Y8CrqFi</a><a href="https://twitter.com/hashtag/BNB?src=hash&amp;ref_src=twsrc%5Etfw">#BNB</a> <a href="https://twitter.com/hashtag/Metasnooker?src=hash&amp;ref_src=twsrc%5Etfw">#Metasnooker</a> <a href="https://twitter.com/hashtag/Metaverse?src=hash&amp;ref_src=twsrc%5Etfw">#Metaverse</a> <a href="https://twitter.com/hashtag/playtoearn?src=hash&amp;ref_src=twsrc%5Etfw">#playtoearn</a> <a href="https://twitter.com/hashtag/Moonshot?src=hash&amp;ref_src=twsrc%5Etfw">#Moonshot</a> <a href="https://twitter.com/hashtag/8ball?src=hash&amp;ref_src=twsrc%5Etfw">#8ball</a> <a href="https://twitter.com/hashtag/Blockshain?src=hash&amp;ref_src=twsrc%5Etfw">#Blockshain</a> <a href="https://t.co/gNDcnPf6Nv">pic.twitter.com/gNDcnPf6Nv</a></p>&mdash; MetaSnooker (@Snooker_Meta) <a href="https://twitter.com/Snooker_Meta/status/1499021560304345089?ref_src=twsrc%5Etfw">March 2, 2022</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
                        </Grid>
                        <Grid 
                            xs={12}
                            sm={6}
                            md={4}
                            className="px-3 my-4"
                            data-aos="zoom-in"
                        >
                            <blockquote class="twitter-tweet" data-dnt="true" data-theme="dark"><p lang="en" dir="ltr">*Huge announcement*<br/><br/>As per our community&#39;s request of choosing three winners instead of one, we&#39;ve implemented according to that!<br/><br/>For every good project, there needs to be a supportive and understanding team. 🙌<a href="https://twitter.com/hashtag/BNB?src=hash&amp;ref_src=twsrc%5Etfw">#BNB</a> <a href="https://twitter.com/hashtag/tothemoon?src=hash&amp;ref_src=twsrc%5Etfw">#tothemoon</a> <a href="https://twitter.com/hashtag/moonshot?src=hash&amp;ref_src=twsrc%5Etfw">#moonshot</a> <a href="https://twitter.com/hashtag/MetaSnooker?src=hash&amp;ref_src=twsrc%5Etfw">#MetaSnooker</a> <a href="https://twitter.com/hashtag/snooker?src=hash&amp;ref_src=twsrc%5Etfw">#snooker</a> <a href="https://twitter.com/hashtag/metaverse?src=hash&amp;ref_src=twsrc%5Etfw">#metaverse</a> <a href="https://t.co/MwNMSxHOf1">pic.twitter.com/MwNMSxHOf1</a></p>&mdash; MetaSnooker (@Snooker_Meta) <a href="https://twitter.com/Snooker_Meta/status/1499059779209084932?ref_src=twsrc%5Etfw">March 2, 2022</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
                        </Grid>
                        <Grid 
                            xs={12}
                            sm={6}
                            md={4}
                            className="px-3 my-4"
                            data-aos="zoom-in"
                        >
                            <blockquote class="twitter-tweet" data-dnt="true" data-theme="dark">
                                <p lang="en" dir="ltr">
                                    MetaSnooker is an online play-to-earn game where players can challenge each other over a pool game to win tokens with real-world value!
                                    <a href="https://twitter.com/hashtag/MetaSnooker?src=hash&amp;ref_src=twsrc%5Etfw">#MetaSnooker</a>
                                    <a href="https://twitter.com/hashtag/Metaverse?src=hash&amp;ref_src=twsrc%5Etfw">#Metaverse</a> 
                                    <a href="https://twitter.com/hashtag/PlayToEarn?src=hash&amp;ref_src=twsrc%5Etfw">#PlayToEarn</a> 
                                    <a href="https://t.co/FnCAQRfmUw">pic.twitter.com/FnCAQRfmUw</a>
                                </p>&mdash; MetaSnooker (@Snooker_Meta) 
                                <a href="https://twitter.com/Snooker_Meta/status/1479435795845074944?ref_src=twsrc%5Etfw">January 7, 2022</a>
                            </blockquote> 
                        </Grid>                        
                        {/* <AnnouncementCards 
                            cardDate = "02 Jan, 2022"
                            title = "Tournaments coming"
                            cardImg = {tweet3}
                            link = "#"
                            cardAnimate = "zoom-in"
                        /> */}
                    </Grid>
                    <Grid
                        xs={12}
                        className="text-center align-self-center mx-auto mt-5"
                    >
                        <a 
                            href="https://twitter.com/Snooker_Meta" 
                            className="MS---Neon--Button btn mt-4" 
                            target="_blank"
                            data-aos="zoom-in"
                        >
                            Join our twitter
                            {/* <div class="bg"></div> */}
                        </a>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}
export default Announcements;